// extracted by mini-css-extract-plugin
module.exports = {"orderedList":"OrderedList_orderedList__j0njx","compactOrderedList":"OrderedList_compactOrderedList__Q9WFN"};